import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { CopilotScriptsService } from '@coach-bot/data-access/copilot-scripts';
import {
  AntipatternConfiguration,
  AntipatternType,
  AntipatternTypeV2,
  AppSyncService,
  AssetsStore,
  CopilotNotificationFeedback,
} from '@coach-bot/data-access/shared';
import { ENVIRONMENT_TOKEN, Environment } from '@environment';
import { ExtensionCommunicationService } from '@shared/extension';
import { BehaviorSubject, Subscription } from 'rxjs';
import { FeedbackStages } from '../../enums';

@Component({
  selector: 'ap-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['../../styles/antipattern-popup-feedback.scss', './feedback.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeedbackComponent implements OnChanges, OnDestroy {
  @Input() configuration: AntipatternConfiguration;
  @Input() processedDescription: string;
  @Input() type: AntipatternType | AntipatternTypeV2;
  @Input() banner: { class?: string; color?: string };
  @Input() notificationId: string;
  @Input() stage: FeedbackStages;

  @Output() onStageChange = new EventEmitter<FeedbackStages>();

  readonly FeedbackStages = FeedbackStages;

  readonly assetsPath$: BehaviorSubject<string> = this.assetsStore.assetsPath$;

  subscriptions: Subscription[] = [];
  note: string = '';
  feedback!: boolean;
  feedbackSent: boolean = false;
  isAntipatternDetected: boolean = false;
  isFeedbackStageForm: boolean = false;

  private copilotScriptsService: CopilotScriptsService;

  constructor(
    private assetsStore: AssetsStore,
    @Inject(ENVIRONMENT_TOKEN) private environment: Environment,
    private extensionCommunicationService: ExtensionCommunicationService
  ) {
    // Disable AppSyncService in beyond.ai extension
    // const appSyncService = new AppSyncService(this.environment);
    // this.copilotScriptsService = new CopilotScriptsService(appSyncService)
  }

  ngOnChanges(): void {
    this.isAntipatternDetected = this.type === AntipatternType.AntipatternDetected;
    this.isFeedbackStageForm = this.stage === FeedbackStages.Form;
  }

  getBannerClass(): string {
    if (this.banner.class) {
      return `coachbot-antipattern-popup-banner ${this.banner.class}`;
    }
    return `coachbot-antipattern-popup-banner`;
  }

  getBannerStyle(): string {
    if (!this.banner.class && this.banner.color) {
      return `background:${this.banner.color};color:${this.configuration?.pillTextColor};border: 1px solid ${this.configuration.pillTextColor}`;
    }
    return '';
  }

  onFeedbackClick(feedback: boolean): void {
    this.sendCopilotNotificationFeedback({
      notificationId: this.notificationId,
      studentFeedback: feedback,
    });
    this.feedback = feedback;
    this.onStageChange.emit(FeedbackStages.Confirmation);
  }

  onAddCommentClick(): void {
    this.onStageChange.emit(FeedbackStages.Form);
  }

  onSaveCommmentClick(): void {
    this.sendCopilotNotificationFeedback({
      notificationId: this.notificationId,
      studentFeedbackNotes: this.note,
    });
    this.feedbackSent = true;
  }

  sendCopilotNotificationFeedback(
    copilotNotificationFeedback: CopilotNotificationFeedback,
  ): void {
    const feedbackMutationSubscription = this.copilotScriptsService.sendCopilotNotificationFeedback(copilotNotificationFeedback)
      .subscribe((res) => console.log(res.setCopilotNotificationFeedback));
    this.subscriptions.push(feedbackMutationSubscription);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
